import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useTranslation } from 'react-i18next';
import PaywallLayout from './PaywallLayout';
import { getDeviationType } from '../../../_helpers';
import { DeviationTypes } from '../../../../types/deviation';
import { ProfileOwnerWatchButton } from '../../../../Button';
import paywallStyles from './Paywall.scss';
const textKeyForDeviationType = (type)=>{
    if (type === DeviationTypes.LITERATURE) {
        return 'deviationview.paywall.artstage.watchersOnly.text.literature';
    }
    if (type === DeviationTypes.FILM) {
        return 'deviationview.paywall.artstage.watchersOnly.text.video';
    }
    return 'deviationview.paywall.artstage.watchersOnly.text';
};
const WatchersOnlyPaywall = (_param)=>{
    var { deviation: { author }, deviation } = _param, props = _object_without_properties(_param, [
        "deviation",
        "deviation"
    ]);
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(PaywallLayout, _object_spread({
        deviation: deviation,
        icon: /*#__PURE__*/ React.createElement("div", {
            className: paywallStyles['watchers-icon']
        }),
        title: t('deviationview.paywall.artstage.watchersOnly.title'),
        text: t(textKeyForDeviationType(getDeviationType(deviation))),
        button: author && /*#__PURE__*/ React.createElement(ProfileOwnerWatchButton, {
            className: paywallStyles['watch-button'],
            user: author,
            onToggleWatchSuccess: ()=>{
                window.location.href = deviation.url;
            }
        })
    }, props));
};
WatchersOnlyPaywall.displayName = 'WatchersOnlyPaywall';
export default WatchersOnlyPaywall;
